export function buildPlutoUrl(plutoBaseUrl?: string, currentUserId?: number) {
  if (!plutoBaseUrl || !currentUserId) return '##';
  return plutoBaseUrl.replace('{userId}', currentUserId?.toString()!!);
}
